<!--
 - Address popover component HTML
 -
 - @version
 - 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<div class="text-center">
  <div *ngIf="address.company">{{address.company}}</div>
  <div>
    <span *ngIf="address.street">{{address.street}},</span>
    <span *ngIf="address.city">{{address.city}}</span>
  </div>
  <div>
    <span *ngIf="address.state">{{address.state?.label}},</span>
    <span *ngIf="address.country">{{address.country?.label}}</span>
  </div>
  <div *ngIf="address.zipcode">{{address.zipcode}}</div>
  <div *ngIf="address.phone">
    <small><bc-atoms-icon type="phone"></bc-atoms-icon></small>
    {{address.phone}}
  </div>
</div>
